/**
 * Picks the rendering backend at module-load time based on the URL flag
 * `?gl=1`. Both backends expose the same shape, so main.ts just imports
 * from here without caring which one is live.
 */

import * as Canvas2D from './render';
import * as WebGL from './render-gl';

// WebGL is the default renderer. Opt out with `?canvas=1` (kept for
// quick A/B comparison and as a fallback if WebGL2 isn't available).
const useGL =
  typeof location === 'undefined' ||
  !new URLSearchParams(location.search).has('canvas');

const R = useGL ? WebGL : Canvas2D;

export const render = R.render;
export const applyEvents = R.applyEvents;
export const fitCanvas = R.fitCanvas;
export const warmStaticCache = R.warmStaticCache;
export const screenToRink = R.screenToRink;

/** Convenience flag — main.ts uses this to show "GL" in the net pill. */
export const usingWebGL = useGL;
